import { memo } from "react";
import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { DiscountListPresenter } from "./presenter";
import * as Repository from "../model/repository";

type Props = {
	hotelID: string;
};

export const DiscountListContainer = memo(({ hotelID }: Props) => {
	const { data } = Repository.Query.useDiscountListForDiscountQuery(hotelID);

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DiscountListPresenter hotelID={hotelID} data={data} />;
});

DiscountListContainer.displayName = "DiscountListContainer";
